import { render, staticRenderFns } from "./whatsapp.vue?vue&type=template&id=700370b5&scoped=true&"
import script from "./whatsapp.vue?vue&type=script&lang=js&"
export * from "./whatsapp.vue?vue&type=script&lang=js&"
import style0 from "./whatsapp.vue?vue&type=style&index=0&id=700370b5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700370b5",
  null
  
)

export default component.exports